import type { AttentionItem } from './api';
import { countLabel } from './display';

type Counted = { source: string; triage_owner?: string | null };

/** Guest messages routed to «требует вас» by inbox/received. */
export function isReceivedGuestMessage(item: { source: string }): boolean {
  return item.source === 'guest_inbox';
}

/**
 * Header and «Только моё» on «Сегодня»: every received guest message is one
 * row, with or without an owner. Other requires-you cards stay separate.
 */
export function ownerScreenDecisionCount(items: readonly Counted[]): number {
  const received = items.filter(isReceivedGuestMessage).length;
  return received === 0 ? items.length : items.length - received + 1;
}

/** «120 сообщений» or «120 сообщений, 40 без ответственного». */
export function receivedMessagesRowTitle(messages: readonly Counted[]): string {
  const total = countLabel(messages.length, 'сообщение', 'сообщения', 'сообщений');
  const unowned = messages.filter((item) => !item.triage_owner).length;
  if (unowned === 0) return total;
  return `${total}, ${unowned.toLocaleString('ru-RU')} без ответственного`;
}

/**
 * «Сегодня» shows one row for every inbox/received guest message.
 * «Входящие» keeps the original cards.
 */
export function collapseReceivedMessages(items: AttentionItem[]): AttentionItem[] {
  const received = items.filter(isReceivedGuestMessage);
  if (received.length === 0) return items;
  const unowned = received.some((item) => !item.triage_owner);
  const summary: AttentionItem = {
    key: 'guest_inbox:received',
    source: 'guest_inbox',
    source_id: 'received',
    title: receivedMessagesRowTitle(received),
    summary: unowned ? null : 'Уже есть ответственный',
    status_label: 'Получено сообщение',
    actor_label: null,
    unit_code: null,
    booking_id: null,
    lead_id: null,
    assignee: null,
    due_at: null,
    href: '/inbox',
    action_label: 'Открыть',
  };
  let inserted = false;
  const visible: AttentionItem[] = [];
  for (const item of items) {
    if (isReceivedGuestMessage(item)) {
      if (!inserted) {
        visible.push(summary);
        inserted = true;
      }
      continue;
    }
    visible.push(item);
  }
  return visible;
}
